import { LoadingButton } from "@babackapp/ui/components/loading-button";
import logoWhiteOther from "@/assets/logoWithName-colors.svg";
import useTranslation from "@babackapp/translations/use-translation";
export const HomeLoading = () => {
  const t = useTranslation();
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="flex-col items-center space-x-4">
        <img className="h-20 w-auto" src={logoWhiteOther} alt="Logo Baback" />

        <div className="flex items-center space-x-1 justify-center">
          <h3 className="text-primary text-xl"> {t("misc.loading")}</h3>
          <LoadingButton isLoading={true} variant="link" />
        </div>
      </div>
    </div>
  );
};
